const steps = [
  {
    no: "01",
    title: "打开今日瓜单",
    desc: "进入首页就能看到按全网热度排好序的今日瓜单，前十名基本就是当天最值得关注的事。",
    icon: "ri-list-ordered-2",
  },
  {
    no: "02",
    title: "扫一遍快报速览",
    desc: "每条热点都被压成一句话摘要，不用点开一堆页面，几十秒就能把重点全部过一遍。",
    icon: "ri-speed-up-line",
  },
  {
    no: "03",
    title: "挑感兴趣的深读",
    desc: "遇到想细看的话题，点进详情页阅读完整内容、相关推荐与同分类的其它快报，一条线索顺下去。",
    icon: "ri-book-open-line",
  },
];

export default function StepsSection() {
  return (
    <section className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-1">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-6 h-[3px] rounded-full bg-accent-500"></span>
              <span className="font-label text-xs tracking-[0.2em] text-accent-400">
                HOW IT WORKS
              </span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 leading-snug mb-4">
              三步，一分钟吃完今天的瓜
            </h2>
            <p className="font-label text-sm text-background-300 leading-relaxed">
              我们把「找热点」这件事拆成了三个很轻的步骤。你不需要记住一堆平台，也不用担心漏掉什么，
              打开就能跟上，关掉也不会有负担。
            </p>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {steps.map((step) => (
              <div
                key={step.no}
                className="relative flex flex-col p-5 md:p-6 rounded-lg bg-background-50/5 border border-background-50/10"
              >
                <span className="font-heading font-black text-3xl md:text-4xl text-accent-500 mb-4">
                  {step.no}
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-100 mb-3">
                  <i className={`${step.icon} text-lg leading-none`}></i>
                </span>
                <h3 className="font-heading font-semibold text-background-50 text-base md:text-lg mb-2">
                  {step.title}
                </h3>
                <p className="font-label text-xs md:text-sm text-background-300 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}